import {Button} from '@chekinapp/ui';
import cn from 'clsx';

import styles from './styles.module.css';
import {ReactNode} from 'react';

type Props = {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  hidden?: boolean;
  children?: ReactNode;
};

function PayButton({className, disabled, onClick, children, hidden}: Props) {
  if (hidden) {
    return null;
  }

  return (
    <div className={cn(styles.paymentBox__row, className, 'checkout-summary-box__row')}>
      <Button
        className="w-full checkout-summary-box__button"
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </Button>
    </div>
  );
}

export {PayButton};
